module.exports = __webpack_public_path__ + "img/verify-id.3a4aec7e.jpg";